export default "__VITE_ASSET__DrAQ4t_t__"